export const REPORTS_REQUEST = 'REPORTS_REQUEST'
export function reportsRequest(filters) {
    return {
        type: REPORTS_REQUEST,
        filters
    }
}

export const REPORTS_REQUEST_SUCCESS = 'REPORTS_REQUEST_SUCCESS'
export function reportsRequestSuccess(reports) {
    return {
        type: REPORTS_REQUEST_SUCCESS,
        reports
    }
}

export const DEVICES_REQUEST = 'DEVICES_REQUEST'
export function devicesRequest(filters) {
    return {
        type: DEVICES_REQUEST,
        filters
    }
}

export const SET_DEVICE_VIEW = 'SET_DEVICE_VIEW'
export function setDeviceView(view) {
    return {
        type: SET_DEVICE_VIEW,
        view
    }
}
